<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'des-valor-km') {
            next({ name: 'des-valor-km-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'des-valor-km') {
            this.$router.push({ name: 'des-valor-km-list' });
        }
    },
};
</script>
